import React from 'react'
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { corporateColor } from '../../../../theme/colors'
import { DOBRA } from '../../../../theme/fonts'
import { CloseIcon, SuccessIcon } from '../../../../components/Svg'
import { useTranslation } from 'react-i18next'

interface Props {
  title?: string
  uri?: string
  desc?: string
  onClose?: () => void
}

export const BodyAlert = ({ title, uri, desc, onClose }: Props) => {
  const { t } = useTranslation()
  return (
    <View style={{ gap: 4 }}>
      <View style={{ alignItems: 'flex-end' }}>
        <TouchableOpacity onPress={onClose}>
          <CloseIcon height={29} width={29} color={corporateColor} />
        </TouchableOpacity>
      </View>
      <View style={{ gap: 8, alignItems: 'center' }}>
        {!!uri && (
          <Image
            source={{ uri }}
            style={{ width: 261, height: 228, borderRadius: 8 }}
            resizeMode='contain'
          />
        )}
        <SuccessIcon height={40} width={40} />
        <Text style={style.title}>{t(title ?? '')}</Text>
        <Text style={style.desc}>{t(desc ?? '')}</Text>
      </View>
    </View>
  )
}

const style = StyleSheet.create({
  title: {
    fontFamily: DOBRA,
    fontSize: 18,
    fontWeight: '500',
    lineHeight: 22,
    textAlign: 'center',
    color: corporateColor,
  },
  desc: {
    fontFamily: DOBRA,
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 20,
    textAlign: 'center',
    color: corporateColor,
  },
})
